import React from 'react';
import './style.scss'
import IconButton from "../IconButton/index.js";
import { fixedNumber } from "../../../utils/math-util.js";
import { useSelector } from 'react-redux';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

const SummaryOrderFilter = () => {
    const { t } = useTranslation();
    const tableData = useSelector(state => state.order.data.customTablePagination);
    const cashPayment = tableData?.cashAmount || 0;
    const cardPayment = tableData?.totalAmount || (tableData?.totalAmount - tableData?.cashAmount) || 0;

    return (
        <Spin spinning={tableData.loading}>
            <div className="summaryOrderFilter">
                <div className="summaryItem">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryOrder" isIcon />
                        <span>{t("orders.ORDERS_INFO_LABLE")}</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.totalOrders}</span>
                    </span>
                </div>

                <div className="summaryItem">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryCash" isIcon />
                        <span>{t("orders.CASH_INFO_LABEL")}</span>
                    </div>
                    <span className="count">{fixedNumber(cashPayment, 2)}</span>
                </div>

                <div className="summaryItem">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryCard" isIcon />
                        <span>{t("orders.CARD_INFO_LABEL")}</span>
                    </div>
                    <span className="count">{fixedNumber(cardPayment, 2)}</span>
                </div>
            </div>
        </Spin>
    );
}

export const SummaryCustomerOrdersFilter = () => {
    const { t } = useTranslation();

    const tableData = useSelector(state => state.order.data?.customTableConfigPagination?.customerService) || {};
    const cashPayment = tableData?.cashAmount || 0;
    const cardPayment = tableData?.cardAmount || 0;

    return (
        <Spin spinning={tableData.loading}>
            <div className="summaryOrderFilter">
                <div className={classNames('summaryItem', 'adaptiveWidth')}>
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryOrder" isIcon />
                        <span className='symmaryOrderItem' >{t("orders.ORDERS_INFO_LABLE")}</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.totalOrders}</span>
                    </span>
                </div>

                <div className="summaryItem adaptiveWidth">
                    <div className="iconLabelRow">
                        <IconButton iconName="orderDeleteDark" isIcon />
                        <span className='symmaryOrderItem'>{t("orders.DELETED_STATUS_LABEL")}:</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.canceledOrdersCount}</span>
                    </span>
                </div>

                <div className="summaryItem">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryCash" isIcon />
                        <span className='symmaryOrderItem'>{t("orders.CASH_INFO_LABEL")}</span>
                    </div>
                    <span className="count">{fixedNumber(cashPayment, 2)}</span>
                </div>

                <div className="summaryItem">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryCard" isIcon />
                        <span className='symmaryOrderItem'>{t("orders.CARD_INFO_LABEL")}</span>
                    </div>
                    <span className="count">{fixedNumber(cardPayment, 2)}</span>
                </div>
            </div>
        </Spin>
    );
}

export const SummaryCustomerConsumerOrdersFilter = () => {
    const { t } = useTranslation();

    const tableData = useSelector(state => state.order.data?.customTableConfigPagination?.customTableUserOrders) || {};
    const cashPayment = tableData?.cashAmount || 0;
    const cardPayment = tableData?.cardAmount || 0;

    return (
        <Spin spinning={tableData.loading}>
            <div className="summaryOrderFilter">
                <div className={classNames('summaryItem')}>
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryOrder" isIcon />
                        <span className='symmaryOrderItem'>{t("orders.ORDERS_INFO_LABLE")}</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.totalOrders}</span>
                    </span>
                </div>

                <div className="summaryItem adaptiveWidth">
                    <div className="iconLabelRow">
                        <IconButton iconName="orderDeleteDark" isIcon />
                        <span className='symmaryOrderItem'>{t("orders.DELETED_STATUS_LABEL")}:</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.canceledOrdersCount}</span>
                    </span>
                </div>

                <div className="summaryItem">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryCash" isIcon />
                        <span className='symmaryOrderItem'>{t("orders.CASH_INFO_LABEL")}</span>
                    </div>
                    <span className="count">{fixedNumber(cashPayment, 2)}</span>
                </div>

                <div className="summaryItem">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryCard" isIcon />
                        <span className='symmaryOrderItem'>{t("orders.CARD_INFO_LABEL")}</span>
                    </div>
                    <span className="count">{fixedNumber(cardPayment, 2)}</span>
                </div>
            </div>
        </Spin>
    );
}

export const SummaryCustomerReviewFilter = () => {
    const { t } = useTranslation();

    const tableData = useSelector(state => state.order.data?.customTableConfigPagination?.customerServiceReview) || {};

    return (
        <Spin spinning={tableData.loading}>
            <div className="summaryOrderFilter">
                <div className={classNames('summaryItem')}>
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryOrder" isIcon />
                        <span className='symmaryOrderItem'>{t("reviews.LABEL")}</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.totalOrders || 0}</span>
                    </span>
                </div>
            </div>
        </Spin>
    );
}

export const SummaryUnfinishedCartFilter = () => {
    const { t } = useTranslation();

    const tableData = useSelector(state => state.order.data?.customTableConfigPagination?.unfinishedCart) || {};

    return (
        <Spin spinning={tableData.loading}>
            <div className="summaryOrderFilter">
                <div className={classNames('summaryItem')}>
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryOrder" isIcon />
                        <span className='symmaryOrderItem'>{t("admin-orders.UNFINISHED_CART_ITEMS")}:</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.totalItems || 0}</span>
                    </span>
                </div>
            </div>
        </Spin>
    );
}


export const SummaryCustomerCustomersFilter = () => {
    const { t } = useTranslation();

    const tableData = useSelector(state => state.order.data?.customTableConfigPagination?.customerServiceCustomers) || {};

    return (
        <Spin spinning={tableData.loading}>
            <div className="summaryOrderFilter">
                <div className="summaryItem noBorder">
                    <div className="iconLabelRow">
                        <IconButton iconName="summaryOrder" isIcon />
                        <span className='symmaryOrderItem'>{t("customers.USERS")}</span>
                    </div>
                    <span className="count">
                        <span>{tableData?.totalCount}</span>
                    </span>
                </div>
            </div>
        </Spin>
    );
}

export default SummaryOrderFilter;